import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

export const fetchVoteDetailsAsync = createAsyncThunk(
  "anket/fetchVoteDetails",
  async (voteId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/votes/pending/${voteId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
